export enum COOKIE_KEYS {
    TOKEN = 'token'
}

export enum LOCALSTORAGE_KEYS {
    USERINFO = 'userInfo',
    NAV_OPEN_KEYS = 'navOpenKeys',
    SIDE_BAR_THEME = 'sideBarTheme',
    SIDE_BAR_COLLAPSED = 'sideBarCollapsed'
}

export const LOGIN_CATEGORY = ['user', 'admin']

// Finance user (Nurit Ak.) — always added as a recipient on cancellation requests.
export const FINANCE_USER_ID = 369


export enum MONTHS {
    JAN = 'יָנוּאָר'  ,
    FEB = 'פברואר',
    MAR = 'מרץ',
    APR = 'אַפּרִיל',
    MAY = 'מאי',
    JUN = 'יוני',
    JUL = 'יולי',
    AUG = 'אוגוסט',
    SEP = 'סֶפּטֶמבֶּר',
    OCT = 'אוֹקְטוֹבֶּר',
    NOV = 'נוֹבֶמבֶּר',
    DEC = 'דֵצֶמבֶּר'

}
export const months : string[] = [MONTHS.JAN,MONTHS.FEB,MONTHS.MAR,
    MONTHS.APR, MONTHS.MAY,MONTHS.JUN,MONTHS.JUL, MONTHS.AUG, MONTHS.SEP,MONTHS.OCT,MONTHS.NOV,MONTHS.DEC]
export const years: number[] = [2020,2021]
